import {Controller} from "stimulus";
import Rails from "@rails/ujs";
let selectedBoxes = {};
let dropDownValues = {};

export default class extends Controller {
  static targets = ["checkBox"]

  checkAllBoxes() {
    let txnAmounts = []
    let checkboxBtn = this.element.querySelector('[data-behaviour="checkbox-link-btn"]')
    let parentCheckBox = this.element.querySelector('[data-behaviour="select-all-checkboxes"]')
    this.element.querySelectorAll('data[behaviour="select-all-checkboxes"]')
    this.element.querySelectorAll('input[id="txn_ids"]').forEach(invoice => txnAmounts.push(invoice.dataset.amount))
    let total = this.commaStyle(txnAmounts.reduce((a, b) => parseInt(a) + parseInt(b)))
    checkboxBtn.innerHTML = "Pay Rs " + total
    this.element.querySelectorAll('input[id="txn_ids"]').forEach(element => element.checked = parentCheckBox.checked)
    if (parentCheckBox.checked) {
      checkboxBtn.removeAttribute("disabled")
    } else {
      (checkboxBtn.setAttribute("disabled", "disabled"), checkboxBtn.innerHTML = "Pay Selected")
    }
  }

  individualBox() {
    let checkboxBtn = this.element.querySelector('[data-behaviour="checkbox-link-btn"]')
    let checkedCheckBoxes = []
    let txnAmounts = []
    this.element.querySelectorAll('[data-behaviour="invoices-checkboxes"]').forEach(item => item.checked ? checkedCheckBoxes.push(item) : null)
    checkedCheckBoxes.length > 0 ? checkboxBtn.removeAttribute("disabled") : (checkboxBtn.setAttribute("disabled", "disabled"), checkboxBtn.innerHTML = "Pay Selected");
    this.element.querySelectorAll('[data-behaviour="invoices-checkboxes"]').forEach(txn => txn.checked ? txnAmounts.push(txn.dataset.amount) : null)
    let total = this.commaStyle(txnAmounts.reduce((a, b) => parseInt(a) + parseInt(b)))
    checkboxBtn.innerHTML = "Pay Rs " + total
  }

  commaStyle(amount) {
    if (amount === 0 || amount === undefined) {
      return '-'
    } else {
      let intl = new Intl.NumberFormat('en-IN')
      return intl.format(amount)
    }
  }


  postIds() {
    let array = [];
    this.element.querySelectorAll('input[id="txn_ids"]').forEach(function (element) {
      if (element.checked) {
        array.push(element.value)
      }
    })
    let checkboxBtn = this.element.querySelector('[data-behaviour="checkbox-link-btn"]')
    let url = checkboxBtn.href
    url = url + "&txn_source_ids=" + array.join(',')
    checkboxBtn.href = url
  }

  checkboxChanged() {
    let checkboxBtn = this.element.querySelector('[data-behaviour="checkbox-link-btn"]')
    let checkedCheckBoxes = []
    this.element.querySelectorAll('[data-behaviour="checkbox-item"]').forEach(item => item.checked ? checkedCheckBoxes.push(item) : null)
    checkedCheckBoxes.length > 0 ? checkboxBtn.removeAttribute("disabled") : checkboxBtn.setAttribute("disabled", "disabled");
  }

  checkboxSubmit() {
    let array = [];
    this.element.querySelectorAll('input[id="checkbox_item_id"]').forEach(function (element) {
      if (element.checked) {
        array.push(element.value)
      }
    })
    let checkboxBtn = this.element.querySelector('[data-behaviour="checkbox-link-btn"]')

    if (checkboxBtn.href !== undefined) {
      let url = checkboxBtn.href
      url = url + "&txn_source_ids=" + array.join(',')
      checkboxBtn.href = url
    } else if (checkboxBtn.form.action !== undefined) {
      let url = new URL(checkboxBtn.form.action)
      url.searchParams.set('selected_ids', array.join(','))
      checkboxBtn.form.action  = url
      Rails.fire(checkboxBtn.form, "submit")
    }
  }

  selectedCheckBox(){
    let selectedBox = this.element.dataset.id
    selectedBoxes[selectedBox] = "hello";
  }

  dropDownSelect(){
    let rowId =  this.element.dataset.id
    let dropDownSelectedValue = this.element.getElementsByTagName('td')[3].dataset.id;
    dropDownValues[rowId] = dropDownSelectedValue;
  }
}